import Cookies from "universal-cookie";
import axios from "axios";

const cookies = new Cookies();

export const placeholderData = (item, values, domain) => {  // this function is for dynamic placeholder data, 
  // values?.education_level is added in OR condition for Update Profile where education level field is not present or required.
  let placeholder = "";
  if (item?.name == "passing_year" || item?.alternate_name == "passing_year") {
    if (values?.education_level?.id == 13 || values?.education_level == 13) {
      placeholder = "12th Passed In";
    }
    else {
      placeholder = (values?.education_level?.id || values?.education_level) + "th " + item?.placeholder;
    }
  } else if (item?.name == "aspiring_stream" || item?.alternate_name == "aspiring_stream") {
    if (values?.education_level?.id || values?.education_level) {
      placeholder =
        (values?.education_level?.id == 11 || values?.education_level == 11)
          ? "Class 11th Stream"
          : item?.placeholder + "Class 11th"
    }
    else {
      placeholder = "Stream Interest"
    }
  } else if (item?.name == "education_interest" || item?.alternate_name == "education_interest") {
    placeholder = ((values?.education_level?.id <= 10 || values?.education_level <= 10) && domain?.id != 2) ?
      "College Education Stream" : item?.placeholder;
  } else if (item?.name == "degree_pursue" || item?.alternate_name == "degree_pursue") {
    if ((values?.education_level?.id >= 17 || values?.education_level >= 17) && (values?.education_level?.id <= 21 || values?.education_level <= 21)) {
      placeholder = `UG ${item?.placeholder}`;
    }
    else if ((values?.education_level?.id >= 22 || values?.education_level >= 22) && (values?.education_level?.id <= 25 || values?.education_level <= 25)) {
      placeholder = "UG Degree Completed";
    }
    else if ((values?.education_level?.id >= 26 || values?.education_level >= 26) && (values?.education_level?.id <= 28 || values?.education_level <= 28)) {
      placeholder = `PG ${item?.placeholder}`;
    }
    else {
      placeholder = "PG Degree Completed";
    }
  }
  else {
    placeholder = item?.placeholder;
  }
  return placeholder;
};

export const createCurrentUrl = () => {
  let domainVal
  const urlParams = new URLSearchParams(window.location.search);
  if (window.location?.hostname?.includes("localhost")) {
    domainVal = urlParams?.get("domain") ?? 'www'
  } else {
    domainVal = window.location.host?.split(".")[0]
  }
  let origin
  if (urlParams?.get("domain") == "certification") {
    origin = "https://www.careers360.business/courses-certifications"
  } else {
    origin = window.location.origin?.includes('localhost') ? `https://${domainVal}${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}` : window.location.origin
  }
  return origin
}

export const getCurrentMonth = () => {
  const currentDate = new Date();
  const currentMonth = currentDate.toLocaleString('default', { month: 'long' });
  return currentMonth;
};

export const certificationPage = (url) => {
  let certificatePage = false;
  if (url?.includes("online-course-odgc") || url?.includes("online-course-odpc")
    || url?.includes("certification-course") || url?.includes("courses-certifications") || url.includes("compare-courses")) {
    certificatePage = true;
  }
  return certificatePage;
}

export const getAbsoluteDestinationUrl = () => {
  const subDomainName = window.location.host?.split(".")[0];
    const urlCheck = window.location.href;
    let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
    window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
    const currentUrl = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
  const urlParams = new URLSearchParams(location.search);
  let destinationParam = urlParams?.get('destination');
  
  if(!destinationParam){
    destinationParam =  createCurrentUrl();
  }
  if (destinationParam && !destinationParam?.startsWith('http://') && !destinationParam?.startsWith('https://')) {
    if(destinationParam?.startsWith("/")){
      destinationParam = window.origin + destinationParam;
    }else {
    destinationParam = window.origin + '/' + destinationParam;
    }
  }
  const modifiedDestinationParam = destinationParam?.endsWith('?') ? destinationParam?.slice(0, -1) : destinationParam;
  urlParams?.delete('destination');
  const queryParams = urlParams?.toString();
  const querysplit = queryParams?.split("&");
  let absoluteURL;
  if(modifiedDestinationParam?.includes("?")){
  const queryString = querysplit.map((param, index) => ('&' + param)).join('');
  absoluteURL = queryParams ? `${modifiedDestinationParam}${queryString}` : modifiedDestinationParam;
  }
  if (!modifiedDestinationParam?.includes("?")){
    const queryString = querysplit.map((param, index) => (index === 0 ? "?" + param : '&' + param)).join('');
  absoluteURL = queryParams ? `${modifiedDestinationParam}${queryString}` : modifiedDestinationParam;
  }
  return absoluteURL

}

//for extracting ids from array of obj
export const IdsCheck = (values) => {  
  let arr = [];
  arr = Array.isArray(values) && values?.length > 0 && values?.map(item =>
    item?.preference_id ?? item.id)
  arr = arr?.length > 0 && arr.filter(item => item !== null && item !== undefined);
  return arr;
}

export const LabelsCheck = (values) => {  
  let arr = [];
  arr = Array.isArray(values) && values?.length > 0 && values?.map(item =>
    item?.label ?? item.value)
  arr = arr?.length > 0 && arr.filter(item => item !== null && item !== undefined);
  return arr;
}

export const deviceType = typeof navigator !== `undefined` && 
  navigator?.userAgent?.toLowerCase()?.includes("mobile") ? "mobile" : "web"; 

// Function to convert string to title case
export const convertToTitleCase = (str) => {
    return str?.split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  export const isSignupPage = window.location.pathname?.includes("/user/register");
  export const isLoginPage = window.location.pathname?.includes("/user/login") && !window.location.pathname?.includes("/user/login/otp-verify");


export const setCookiesAndRedirectionOnLogin = (data) => {
  //getting destinationDomain for cookies domain
  const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;
  // -------------- set Login session cookies -----------------
      // Set JWT access cookie
      if(data?.cookies?.c360_jwt_access){
        cookies.set("c360_jwt_access", data?.cookies?.c360_jwt_access, {
            path: "/",
            domain: destinationDomain,
            expires: new Date(data?.cookies?.access_expiry_time),
            sameSite: "Lax"
        })
        }
        // Set JWT refresh cookie
        if(data?.cookies?.c360_jwt_refresh){
        cookies.set("c360_jwt_refresh", data?.cookies?.c360_jwt_refresh, {
            path: "/",
            domain: destinationDomain,
            expires: new Date(data?.cookies?.refresh_expiry_time),
            sameSite: "Lax"
        })}
        // Set session ID cookie
        if(data?.cookies?.sessionid){
        cookies.set("sessionid", data?.cookies?.sessionid, {
            path: "/",
            domain: destinationDomain,
            expires: new Date(data?.cookies?.session_expiry_time),
            sameSite: "Lax"
        })}
        // Set user session data cookie
        if(data?.user_session_data?.session){
        cookies.set(data?.user_session_data?.session, data?.user_session_data?.sid, {
            path: "/",
            domain: destinationDomain,
            expires: new Date(data?.cookies?.session_expiry_time),
            sameSite: "Lax"
        })}
  
        // Set CloudFront cookie
        if(data?.user_session_data?.cloudfront_cookie){
        cookies.set(data?.user_session_data?.cloudfront_cookie, data?.user_session_data?.cloudfront_cookie_value, {
            path: "/",
            domain: destinationDomain,
            expires: new Date(data?.cookies?.session_expiry_time),
            sameSite: "Lax"
        })}
        // Remove unnecessary cookies which are created during login or signup and not needed after successful login.
        cookies.remove("registrationState", {
            path: "/",
            domain: destinationDomain,
        });
        cookies.remove("loginState", {
            path: "/",
            domain: destinationDomain,
        });
        cookies.remove("user-agent-key", {
            path: "/",
            domain: destinationDomain,
        });
        cookies.remove("common_embbed_fields", {
            path: "/",
            domain: destinationDomain,
        });
        // one click url related cookies removed
        cookies.remove("mv_status", {
          path: "/",
          domain: destinationDomain,
        });
        cookies.remove("up_status", {
          path: "/",
          domain: destinationDomain,
        });
        cookies.remove("one-click-login", {
          path: "/",
          domain: destinationDomain,
        });
        // rediercting to destination URL after succesful login.
        if (data?.destination) {
            window.location.href = data?.destination
        }
}